import ViewMixin from "@/mixins/ViewMixin";

const CANCELADA_STATUS = "CANCELADA";

export const STATUSES_TEXT = {
  CORRETOR_ANALISE_CREDITO: "Formulário de Crédito",
  CORRETOR_ANALISE_SUBSCRICAO: "Analise de Subscrição",
  CORRETOR_ANALISE_RESSEGURO: "Analise de Resseguro"
};

export const STATUS_QUESTIONAMENTO_VALIDOS = [
  "CORRETOR_ANALISE_CREDITO",
  "CORRETOR_ANALISE_SUBSCRICAO",
  "CORRETOR_ANALISE_RESSEGURO",
  "CORRETOR_ANALISE_EMISSAO",
];

export const DOWNLOAD_ACTIONS = {
  true: [{
    descricao: "Apólice",
    icone: "picture_as_pdf",
    action: "getDocumentoApolice",
  }, {
    descricao: "Boleto",
    icone: "picture_as_pdf",
    action: "getBoleto",
  }],
  false: [{
    descricao: "Apólice",
    icone: "picture_as_pdf",
    action: "getDocumentoApolice",
  }]
};

export const ENDOSSO_ACTIONS = {
  descricao: "Cancelamento",
  icone: "cancel",
  action: "setShowEndossoCancelamentoDialog"
};

export default {
  mixins: [ViewMixin],
  methods: {
    getProposalStatusText(status) {
      return STATUSES_TEXT[status];
    },

    async getDocumentoApolice() {
      let payload = {
        id_proposta: this.$route.params.propostaId,
        id_produto: this.$route.params.produtoId,
        id_apolice: this.proposal.id_apolice,
      };
      let data;
      try {  
        this.showLoadingIndicator();
        data = await this.GET_DOCUMENTO_APOLICE(payload);
      } catch (e) {
        e.response.data = {
          code: 5013,
          message: "Não foi possível gerar a documento da apólice.",
          title: "Documento da apólice não disponível.",
        };
        this.defaultHandlerError(e);
      }
      this.hideLoadingIndicator();
      this.$forceUpdate();
    },

    async getBoleto() {
      let payload = {
        id_proposta: this.$route.params.propostaId,
        id_produto: this.$route.params.produtoId,
        id_apolice: this.proposal.id_apolice,
      };
      let data;
      try {
        this.showLoadingIndicator();
        data = await this.GET_BOLETO(payload);
      } catch (e) {
        this.defaultHandlerError(e);
      } finally {
        this.hideLoadingIndicator();
        this.$forceUpdate();
      }
    },

    async quitProposal() {
      //if (!this.$route.params.propostaId || !this.$route.params.produtoId)
      //  return this.$router.push({ path: "/mesa-de-trabalho" });
      console.log('mixin');
      let payload = {
        id_proposta: this.$route.params.propostaId,
        id_produto: this.$route.params.produtoId,
      };
      if (this.id_motivo > 0) payload.id_motivo = this.id_motivo;
      if (this.observacao != "") payload.observacao = this.observacao;

      this.modalDesistir = false;
      this.showLoadingIndicator();
      try {
        payload.status = CANCELADA_STATUS;

        await this.QUIT_PROPOSAL(payload);
        return this.$router.push({ path: "/mesa-de-trabalho" });
      } catch (e) {
        this.defaultHandlerError(e);
        return;
      } finally {
        this.hideLoadingIndicator();
      }
    },

    async desistir() {
      console.warn("desistindo da proposta");

      // Buscar motivos
      try {
        this.motivos = await this.$store.dispatch("GET_REASONS");
      } catch (e) {
        this.defaultHandlerError(e);
        return;
      } finally {
        this.hideLoadingAskWait();
      }

      this.modalDesistir = true;
    },

    async sendQuestionamento(data) {
      if (data == "") {
        this.errorModal = true;
        this.error.title = "Aviso";
        this.error.message = "Favor informar uma observação.";
        this.hideLoadingAskWait();
        return;
      }

      try {
        this.showLoadingAskWait();
        await this.POST_QUESTIONAMENTO({
          observacoes: data || "",
          propostaId: +this.$route.params.propostaId,
          produtoId: +this.$route.params.produtoId,
        });
        this.dialogQuestionamento = false;
        this.questionamentoSucessoModal = true;
      } catch (e) {
        this.defaultHandlerError(e);
      } finally {
        this.hideLoadingAskWait();
      }
    },

    getBotaoOpcoes(type) {
      let opcoes = [];
      switch (type) {
      case "Download": {
        opcoes = opcoes.concat(
          DOWNLOAD_ACTIONS[
            this.proposal.status == this.EMITIDA_STATUS
          ]
        );
      } break;
      case "Endosso": {
        opcoes.push(ENDOSSO_ACTIONS);
      } break;
      }
      return opcoes;
    },

  }
};



// WEBPACK FOOTER //
// ./src/mixins/PropostaMixin.js